module.exports = __webpack_public_path__ + "img/marriot-res.42561bdb.png";